import {http} from "Services/Http/HttpClient";

export const setDefaultPaymentCard = async (cardId: string): Promise<any> => {
    return await http.put(`payment-methods/${cardId}/default`, {})
}

export const deletePaymentCard = async (cardId: string): Promise<any> => {
    return await http.delete(`payment-methods/${cardId}`)
}
